import * as Highcharts from "highcharts";
import { GenericUtils } from './../../../utilities/generic-utils';
const genericUtils = new GenericUtils();
// chart with 2 lines

export const chartData = {
  chart: {
    type: "waterfall"
  },

  title: {
    text: ""
  },

  xAxis: {
    type: "category"
  },

  yAxis: {
    title: {
      text: "No of Units"
    }
  },

  legend: {
    enabled: false
  },

  tooltip: {
    formatter: function() {
      return `Total Units Ordered: ${genericUtils.amountIndianUnit(this.point.myData.total)} <br/>
      Delivered: ${genericUtils.amountIndianUnit(this.point.myData.delivered)}<br>
      In Transit: ${genericUtils.amountIndianUnit(this.point.myData.in_transit)}<br>
      BBND: ${genericUtils.amountIndianUnit(this.point.myData.invoiced)}<br>
      To Be invoiced: ${genericUtils.amountIndianUnit(this.point.myData.to_be_invoiced)}`;
    }
  },

  series: [
    {
      upColor: Highcharts.getOptions().colors[2],
      color: Highcharts.getOptions().colors[3],
      borderColor: "#fffff",
      data: [
        {
          name: "Total Units ordered",
          y: 99,
          color: "#007FD8"
        },
        {
          name: "Delivered",
          y: -23,
          color: "#2CB46C"
        },
        {
          name: "In Transit",
          y: -50,
          color: "#EAC843"
        },
        {
          name: "BBND",
          y: -12,
          color: "#F5A623"
        },
        {
          name: "To Be Invoiced",
          y: -14,
          color: "#CF263B"
        }
      ],
      dataLabels: {
        enabled: false,
        formatter: function() {
          return this.point.name;
        },

        style: {
          width: "100px",
          color: "#FFFFFF",
          fontWeight: "bold",
          textShadow: "0px 0px 3px black"
        }
      },
      pointPadding: 0
    }
  ]
};
